import { PasswordFormParams } from "../../../types/login";
import { FormValidationConfig } from "../Form.types";

export const createPasswordFormValidation =
  (): FormValidationConfig<PasswordFormParams> => ({
    password: {
      required: true,
      requiredMessage: "Password is required",
    },
  });
